<template>
	<div
		:class="[
			'text-gray-700 focus-within:text-orange-500',
			markInvalid ? 'text-red-500' : '',
		]"
	>
		<div class="flex justify-between flex-wrap">
			<label class="block font-medium" :for="inputId" v-if="!noLabel">{{
				__(label)
			}}</label>
			<span class="text-red-500" v-if="markInvalid">
				{{ validationMessage }}
			</span>
			<span class="text-gray-500" v-else-if="!required">optional</span>
		</div>
		<div class="mt-1 relative">
			<ui-input
				v-model="val"
				:type="type"
				:id="inputId"
				:autocomplete="autocomplete"
				:inputId="inputId"
				:disabled="disabled"
				:markInvalid="markInputInvalid"
				:dp="dp"
				:maxValue="maxValue"
				:showZeroValue="showZeroValue"
			/>
			<div
				class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
				v-if="markInvalid"
			>
				<ui-icon class="h-5 w-5" name="alert-triangle" stroke-width="1.5" />
			</div>
			<div
				v-else-if="suffix"
				class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
			>
				<span class="text-gray-500">
					{{ suffix }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		field: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: "text",
		},
		autocomplete: {
			type: String,
			default: "on",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		suffix: {
			type: String,
			required: false,
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		dp: {
			type: Number,
			default: null,
		},
		maxValue: {
			type: Number,
			default: null,
			required: false,
		},
		showAsInvalid: {
			type: Boolean,
			default: false,
			required: false,
		},
		showZeroValue: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {
			val: this.value,
			originalVal: this.value,
		};
	},
	computed: {
		markInvalid() {
			return this.form.hasErrors && this.form.errors[this.field] != null;
		},
		markInputInvalid() {
			return (
				(this.markInvalid && this.val == this.originalVal) || this.showAsInvalid
			);
		},
		validationMessage() {
			return this.form.errors[this.field] || "";
		},
		inputId() {
			return "input-" + this._uid;
		},
	},
	watch: {
		val(v) {
			this.$emit("input", v);
			this.$emit("change");
		},
	},
	methods: {
		validationEventListener() {
			let that = this;
			console.log(
				"is-mark-invalid",
				that.field,
				that.markInvalid,
				that.mounted
			);
			that.$bus.$emit("is-mark-invalid", that.field, that.markInvalid);
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	beforeDestroy() {
		console.log("TURNING OFF", this.field);
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
	},
};
</script>
